<script lang="ts">
  import * as DropdownMenu from "@/components/ui/dropdown/";
  import { user } from "@/stores/user";

  import { Image } from "@/components/ui/image";
  import ProfileMenuContent from "./profile-menu-content.svelte";

  import AnonymouseUser from "@/images/anonymous.jpg?raw";

  interface Props {
    open?: boolean;
  }

  let { open = $bindable(false) }: Props = $props();
</script>

<DropdownMenu.Root {open}>
  <DropdownMenu.Trigger class="flex gap-2">
    {#if $user?.image}
      <img
        src={$user.image}
        alt="user avatar"
        class="h-10 w-10 rounded-[8px] border border-dark-gray object-cover" />
    {:else}
      <Image
        src={AnonymouseUser}
        class="h-10 w-10 rounded-[8px] border border-dark-gray object-cover" />
    {/if}
  </DropdownMenu.Trigger>
  <DropdownMenu.Content class="mt-4 border-none bg-transparent p-0">
    <ProfileMenuContent />
  </DropdownMenu.Content>
</DropdownMenu.Root>
